"use strict";import{ButtonGroup as o}from"./src/ButtonGroup.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-button-group",o);
//# sourceMappingURL=sp-button-group.js.map
